import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { ThemeProvider, createTheme, darken, lighten } from '@mui/material/styles';
import baseTheme from '../theme';
import { useTenant } from './TenantProvider';

interface TenantThemeProviderProps {
  children: ReactNode;
}

function brandedPaletteColor(color: string) {
  return {
    main: color,
    light: lighten(color, 0.18),
    dark: darken(color, 0.18),
    contrastText: baseTheme.palette.getContrastText(color),
  };
}

export function TenantThemeProvider({ children }: TenantThemeProviderProps) {
  const { activeTenant } = useTenant();
  const primaryColor = activeTenant?.branding?.primaryColor || baseTheme.palette.primary.main;
  const secondaryColor = activeTenant?.branding?.secondaryColor || baseTheme.palette.secondary.main;

  const tenantTheme = useMemo(
    () =>
      createTheme(baseTheme, {
        palette: {
          primary: brandedPaletteColor(primaryColor),
          secondary: brandedPaletteColor(secondaryColor),
        },
      }),
    [primaryColor, secondaryColor]
  );

  return <ThemeProvider theme={tenantTheme}>{children}</ThemeProvider>;
}
